export const DocumentTypesPluginSettings: IPluginSettings = {
    name: 'Типы документов',
    mnemocode: 'document_types_plugin',
    permission: 'DocumentTypes',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'idGlobal',
            visibility: false,
            width: 200
        },
        {
            order: 1,
            propertyName: 'documentTypes',
            propertyType: 'string',
            displayName: 'documentTypes',
            visibility: false,
            width: 500
        },
        {
            order: 1,
            propertyName: 'displayName',
            propertyType: 'string',
            displayName: 'Типы документов',
            visibility: true,
            width: 500
        },
    ]
}
